<template>
  <div class="container orders-detail-page">
    <v-head></v-head>
    <v-left current="orders"></v-left>
    <div v-if="loading" class="my-loading"><i class="el-icon-loading"></i></div>
    <div v-else-if="detail" class="o-detail-con relative">
      <div class="o-main o-d-block">
        <div class="he-tips">
          <b style="font-size: 16px">订单详情</b>
          <div class="handle-s">
            <span
              class="pointer gray-color"
              @click="popName = 'popLogisticsInfo'"
              v-if="detail.logistics_no != ' '"
              >查看物流</span
            >
            <span
              class="pointer gray-color"
              @click="popName = 'markFail'"
              v-if="in_array(detail.order_status, [2, 3])"
              >标记失败</span
            >
            <span
              class="pointer gray-color"
              @click="popName = 'popRefund'"
              v-if="in_array(detail.order_status, [5])"
              >添加退款记录</span
            >
            <span
              class="pointer gray-color"
              @click="doRefund"
              v-if="detail.last_refund"
              >执行退款</span
            >
          </div>
        </div>
        <table class="table">
          <tr>
            <td class="td-1">订单号</td>
            <td class="td-2">
              <p>{{ detail.order_no }}</p>
              <p>SPF: #<a :href="'xxx'" target="_blank">{{detail.ebay_order_number}}</a></p>
            </td>
          </tr>
          <tr>
            <td class="td-1">买家</td>
            <td class="td-2" v-if="detail.address_info">
              <span
                >{{
                  detail.address_info.last_name +
                  " " +
                  detail.address_info.first_name
                }}, {{ detail.address_info.address }},
                {{ detail.address_info.city }}, {{ detail.address_info.state }},
                {{ detail.address_info.country }}, {{detail.email}}</span
              >
            </td>
          </tr>
          <tr>
            <td class="td-1">订单状态</td>
            <td class="td-2">
              <el-tag :type="detail.order_status_show.u_tag">{{
                detail.order_status_show.label
              }}</el-tag>
            </td>
          </tr>
          <tr>
            <td class="td-1">订单金额</td>
            <td class="td-2">
              ¥{{ detail.amount_total }} （原价：¥{{ detail.amount_original }}）
            </td>
          </tr>
          <tr>
            <td class="td-1">实付金额</td>
            <td class="td-2">¥{{ detail.amount_total_payed }}</td>
          </tr>
          <tr>
            <td class="td-1">应用类型</td>
            <td class="td-2">{{ detail.app_name_full }}</td>
          </tr>
          <tr>
            <td class="td-1">下单时间</td>
            <td class="td-2">{{ detail.ctime }}</td>
          </tr>
          <tr>
            <td class="td-1">支付时间</td>
            <td class="td-2">{{ detail.pay_time }}</td>
          </tr>
          <tr>
            <td class="td-1">订单明细</td>
            <td class="td-2">
              <el-table :data="detail.goods" style="width: 100%">
                <el-table-column prop="sku" label="SKU" min-width="100">
                  <template slot-scope="scope2">
                    <p style="color: gray">
                      {{ scope2.row.model_name }}
                      /
                      {{ scope2.row.brand_name_en }}
                    </p>
                    <p>{{ scope2.row.goods_title }}</p>
                    <p>{{ scope2.row.sku_code }}</p>
                    <p><a :href="scope2.row.shopify_product_url" target="_blank">{{scope2.row.shopify_variant_id}}</a></p>
                  </template>
                </el-table-column>
                <el-table-column prop="price" label="价格" width="155">
                  <template slot-scope="scope2">
                    <p>
                      价格：{{ detail.currency }}
                      {{ scope2.row.price_current }}
                    </p>
                    <p>数量：x {{ scope2.row.quantity }}</p>
                  </template>
                </el-table-column>
                <el-table-column prop="shopify_variable_image" label="SPF" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      :src="scope2.row.shopify_variable_image"
                      :preview-src-list="[scope2.row.shopify_variable_image]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="LINE" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px"
                      :src="scope2.row.image_sku_line"
                      :preview-src-list="[scope2.row.image_sku_line]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="mask" label="MASK" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px; border: 1px dashed #dfdfdf"
                      :src="scope2.row.image_sku_mask"
                      :preview-src-list="[scope2.row.image_sku_mask]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="DIY" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px; border: 1px dashed #dfdfdf"
                      :src="scope2.row.image_diy"
                      :preview-src-list="[scope2.row.image_diy]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="DRAW" width="88">
                  <template slot-scope="scope2">
                    <el-image
                      style="width: 44px; border: 1px dashed #dfdfdf"
                      :src="scope2.row.image_diy_draw"
                      :preview-src-list="[scope2.row.image_diy_draw]"
                    >
                    </el-image>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="PROD" width="88">
                  <template slot-scope="scope2">
                    <div
                      @click="popProduceImage(scope2.row)"
                      style="cursor: pointer"
                    >
                      <img
                        v-if="scope2.row.image_produce"
                        :src="scope2.row.image_produce"
                        style="width: 44px"
                      />
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </td>
          </tr>
          <tr>
            <td class="td-1">生产记录</td>
            <td class="td-2">
              <el-table :data="detail.produce_record" style="width: 100%">
                <el-table-column prop="factory_name" label="工厂" width="222">
                  <template slot-scope="scope2">
                    <a class="pointer" @click="submitOrder(scope2.row)"
                      >提交订单</a
                    >
                    <div v-if="scope2.row.factory_name">
                      <p>{{ scope2.row.factory_name }}</p>
                      <div>
                        <el-tag>{{
                          scope2.row.produce_status_show.label
                        }}</el-tag>
                      </div>
                      <div>
                        <el-input
                          size="small"
                          class="w200"
                          v-model="scope2.row.factory_order_no"
                          placeholder="工厂单号"
                          @blur="saveFactoryOrderNo(scope2.row)"
                        ></el-input>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="order_no" label="收货地址" width="222">
                  <template slot-scope="scope2">
                    <div v-if="scope2.row.request_params">
                      {{ scope2.row.request_params.buyer_name }},
                      {{ scope2.row.request_params.buyer_phone }},
                      {{ scope2.row.request_params.city
                      }}{{ scope2.row.request_params.buyer_address }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="id" label="生产明细" min-width="333">
                  <template slot-scope="scope">
                    <el-table
                      :data="scope.row.produce_goods"
                      style="width: 100%"
                    >
                      <el-table-column prop="sku" label="SKU" min-width="200">
                        <template slot-scope="scope2">
                          <p style="color: gray">
                            {{
                              scope2.row.system_brand_name_en +
                              "/" +
                              scope2.row.system_model_name
                            }}
                          </p>
                          <p>
                            <b>{{ scope2.row.sku_code }}</b> /
                            {{ scope2.row.goods_title }}
                          </p>
                          <div style="border: 1px dashed gray">
                            <p>
                              {{
                                scope2.row.material_info.factory_material_name
                              }}
                            </p>
                            <p>
                              factory_data_id:{{
                                scope2.row.material_info.factory_data_id
                              }}
                            </p>
                          </div>
                        </template>
                      </el-table-column>
                      <el-table-column prop="order_no" label="LINE" width="88">
                        <template slot-scope="scope2">
                          <el-image
                            style="width: 44px"
                            :src="scope2.row.image_sku_line"
                            :preview-src-list="[scope2.row.image_sku_line]"
                          >
                          </el-image>
                        </template>
                      </el-table-column>
                      <el-table-column prop="mask" label="MASK" width="88">
                        <template slot-scope="scope2">
                          <el-image
                            style="width: 44px"
                            :src="scope2.row.image_sku_mask"
                            :preview-src-list="[scope2.row.image_sku_mask]"
                          >
                          </el-image>
                        </template>
                      </el-table-column>
                      <el-table-column prop="order_no" label="DIY" width="88">
                        <template slot-scope="scope2">
                          <el-image
                            style="width: 44px; border: 1px dashed #dfdfdf"
                            :src="scope2.row.image_diy"
                            :preview-src-list="[scope2.row.image_diy]"
                          >
                          </el-image>
                        </template>
                      </el-table-column>
                      <el-table-column prop="order_no" label="DRAW" width="88">
                        <template slot-scope="scope2">
                          <el-image
                            style="width: 44px; border: 1px dashed #dfdfdf"
                            :src="scope2.row.image_diy_draw"
                            :preview-src-list="[scope2.row.image_diy_draw]"
                          >
                          </el-image>
                        </template>
                      </el-table-column>
                      <el-table-column prop="order_no" label="PROD" width="88">
                        <template slot-scope="scope2">
                          <div
                            @click="popProduceImage(scope2.row)"
                            style="cursor: pointer"
                          >
                            <img
                              v-if="scope2.row.image_produce"
                              :src="scope2.row.image_produce"
                              style="width: 44px; border: dashed 1px #dfdfdf"
                            />
                            <i
                              v-else
                              class="el-icon-plus avatar-uploader-icon"
                              style="
                                width: 64px;
                                height: 64px;
                                line-height: 64px;
                              "
                            ></i>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </el-table-column>
              </el-table>
              <a class="pointer" @click="addProduce">+新增</a>
            </td>
          </tr>
          <tr>
            <td class="td-1">退款明细</td>
            <td class="td-2">
              <el-table :data="detail.refund">
                <el-table-column
                  prop="refund_no"
                  label="退单号"
                  min-width="100"
                >
                </el-table-column>
                <el-table-column
                  prop="out_refund_no"
                  label="平台退单号"
                  min-width="222"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="refund_amount"
                  label="退款金额"
                  min-width="88"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="refund_reason"
                  label="退款原因"
                  min-width="133"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="status"
                  label="退款状态"
                  min-width="88"
                  align="center"
                >
                  <template slot-scope="scope">
                    <el-tag size="mini" :type="scope.row.statusShow.u_tag">{{
                      scope.row.statusShow.label
                    }}</el-tag>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="refund_time"
                  label="退款时间"
                  min-width="133"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="ctime"
                  label="创建时间"
                  min-width="133"
                  align="center"
                >
                </el-table-column>
              </el-table>
            </td>
          </tr>
          <tr>
            <td class="td-1">订单文字</td>
            <td class="td-2">
              <div>
                {{ detail.diy_upload_form_text }}
              </div>
            </td>
          </tr>
          <tr>
            <td class="td-1">订单图片</td>
            <td class="td-2">
              <div>
                <el-image
                    v-for="(im, index_im) in detail.diy_upload_files"
                    :key="index_im"
                    style="width:200px;height:auto;"
                    :src="im.fileOss"
                    :preview-src-list="[im.fileOss]"
                  >
                </el-image>
              </div>
            </td>
          </tr>
        </table>

      </div>
      <div class="o-left o-d-block">
        <div class="blo-one">
          <h3 class="block-title">订单日志</h3>
          <el-timeline>
            <el-timeline-item
              v-for="(activity, index) in detail.logs"
              :key="index"
              :timestamp="activity.ctime"
            >
              <div>
                <p>
                  <b>{{ activity.title }}</b>
                </p>
                <p>
                  <span class="gray-color">{{ activity.remark }}</span>
                </p>
                <p v-for="(pa, index_pa) in activity.content" :key="index_pa">
                  <span>{{ pa.label }}：</span>
                  <span>{{ pa.value }}</span>
                </p>
              </div>
            </el-timeline-item>
          </el-timeline>
        </div>
      </div>
    </div>
    <component
      :is="popName"
      :orderInfo="detail"
      :order_goods_row="edit_order_goods_row"
      :logistics_no="detail ? detail.logistics_no : ''"
    ></component>
  </div>
</template>
<script>
import head from "@/pages/public/_head";
import left from "@/pages/public/_left";
const popRefund = (resolve) => require(["@/pages/refund/_pop_edit"], resolve);
const markFail = (resolve) => require(["@/pages/orders/_pop_fail"], resolve);
const popLogisticsInfo = (resolve) => require(["@/pages/logistics/_pop_track"], resolve);
const pop_pro_image = (resolve) => require(["@/pages/orders/_pop_pro_image"], resolve);
const pop_add_produce = (resolve) => require(["@/pages/orders/_pop_add_produce"], resolve);
export default {
  components: {
    "v-head": head,
    "v-left": left,
    popRefund,
    markFail,
    popLogisticsInfo,
    pop_pro_image,
    pop_add_produce,
  },
  data() {
    return {
      loading: false,
      order_id: 0,
      edit_order_goods_row: null,
      detail: null,
      popName: null,
    };
  },
  methods: {
    popProduceImage(goods_row) {
      this.edit_order_goods_row = goods_row;
      this.popName = "pop_pro_image";
    },
    addProduce(goods_row) {
      this.popName = "pop_add_produce";
    },
    saveFactoryOrderNo(produce_row) {
      this.$http
        .post("/v1/pri/factory-orders/save-factory-order-no", {
          produce_id: produce_row.id,
          factory_order_no: produce_row.factory_order_no,
        })
        .then((response) => {
          this.$store.commit("setLoading", { text: false });
          var res = response.data;
          if (res.code == 1) {
            this.$message({
              type: "success",
              message: "操作成功",
            });
            this.getDetail();
          } else {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
        });
    },
    submitOrder(produce_row) {
      this.$confirm("确定提交订单到工厂？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在提交.." });
        this.$http
          .post("/v1/pri/factory-orders/submit", {
            produce_id: produce_row.id,
          })
          .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "操作成功",
              });
              setTimeout(() => {
                this.getDetail();
              }, 1000);
            } else {
              this.$message({
                type: "warning",
                message: res.msg,
              });
            }
          });
      });
    },
    doRefund() {
      this.$confirm("此操作将请求通道执行退款, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$store.commit("setLoading", { text: "正在提交.." });
        this.$http
          .post("/v1/pri/refund/do-recharge", {
            refund_id: this.detail.last_refund.id,
          })
          .then((response) => {
            this.$store.commit("setLoading", { text: false });
            var res = response.data;
            if (res.code == 1) {
              this.$message({
                type: "success",
                message: "退款已提交至平台受理!",
              });
              setTimeout(() => {
                this.getDetail();
              }, 1000);
            }
          });
      });
    },
    getDetail() {
      this.loading = true;
      this.$http
        .post("/v1/pri/orders/detail", { order_id: this.order_id })
        .then((response) => {
          var res = response.data;
          if (res.code == 1) {
            this.detail = res.data;
          }
          this.loading = false;
        });
    },
  },
  mounted() {
    this.order_id = this.getUrlParam("order_id");
    this.getDetail();
  },
};
</script>
<style scoped>
.orders-detail-page {
  background-color: rgb(244, 244, 244);
}
.orders-detail-page .he-tips {
  margin-bottom: 10px;
  position: relative;
}
.orders-detail-page .he-tips .handle-s {
  position: absolute;
  top: 0;
  right: 0;
}
.orders-detail-page .o-detail-con {
}
.orders-detail-page .o-d-block {
  background-color: #fff;
  padding: 20px;
  box-sizing: border-box;
}
.orders-detail-page .o-detail-con .o-main {
  margin-right: 320px;
  margin-bottom: 300px;
}
.orders-detail-page .o-detail-con .o-left {
  width: 300px;
  position: absolute;
  top: 0;
  right: 0;
}
.orders-detail-page .table td {
  border: 1px solid #efefef;
}
.orders-detail-page .block-title {
  padding: 10px 0;
  padding-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/orders/Detail.vue